import { notify, SelectOption, ShowInfo} from './../utils';
import {FormProvider, useForm} from 'react-hook-form';
import {useState} from 'react';
import {Toaster} from 'react-hot-toast';
import { TextArea } from '../utils/TextArea';
import { updateService } from '../../api/AdminPortalApi';

export default function LoginAdmin() {

    const methods = useForm();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [succMessage, setSuccMessage] = useState('');

    const onSubmit = methods.handleSubmit(data => {
        setIsSubmitted(true);

        const serviceData = {
            "message": data.message,
            "isActive": data.isActive.value == 1 ? false : true
        }

        updateService(serviceData).then(response => {
            setIsSubmitted(false)
            setSuccMessage('اطلاعات با موفقیت به روز رسانی شد.')
        }).catch(error => {
            if(error?.response?.data?.message) {
                notify(error?.response?.data?.message)
            }
            setIsSubmitted(false)
        })

    })


    return (

        <div>
            <Toaster/>
            <ShowInfo
                title={'پنل مدیریت'}
            />

            <FormProvider {...methods}>
                <form
                    onSubmit={e => e.preventDefault()}
                    noValidate
                    className="container"
                >
                    {succMessage && 
                        <div class="alert alert-success" role="alert">
                            {succMessage}
                        </div>
                    }
                    <TextArea
                        lable_text="متن پیام"
                        type="text"
                        name="message"
                        placeholder="متن پیام خود را وارد کنید"
                        validation={{
                            required: {
                                value: true,
                                message: 'لطفا پیام مرتبط را وارد کنید',
                            },
                        }}
                    />

                    <SelectOption
                        lable_text={'غیر فعال کردن سرویس؟'}
                        optionList={[ {value: 1, label: 'بله'}, {value: 0, label: 'خیر'}]}
                        name={'isActive'}
                        errorMessage={'یک حالت را انتخاب کنید'}
                    />

                    <div className='row justify-content-center mb-5 mt-5 '>
                        <div className='col-12 col-md-5'>
                            <button
                                onClick={onSubmit}
                                className='btn w-100 text-form-button'
                                style={{"background": "#044448"}}
                                disabled={isSubmitted}>
                                ثبت اطلاعات
                            </button>
                        </div>
                    </div>
                </form>
            </FormProvider>


            {isSubmitted && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}

        </div>

    )
}